module.exports = {
  channelName: 'ชื่อช่องทาง',
  simQueryPlaceholder: 'กรุณากรอกชื่อช่องทาง',
  shippingType: 'วิธีการขนส่ง',
  destinationDistribution: 'วิธีการจัดส่งปลายทาง',
  chargingMethod: 'วิธีการคิดค่าบริการ',
  acceptableGoods: 'สินค้าที่รับได้',
  settlementWeightRoundingRules: 'กฎการปัดเศษน้ำหนักในการชำระเงิน',
  creator: 'ผู้สร้าง',
  bubbleCountingRatio: 'ค่าสัมประสิทธิ์การคิดค่าปริมาตร',
  bubbleSplittingRatio: 'อัตราส่วนการแบ่งค่าปริมาตร',
  multipleBoxesCalculationRules: 'กฎการคำนวณหลายกล่อง',
  singleBoxLowestBillableWeight: 'น้ำหนักขั้นต่ำในการคิดค่าบริการต่อกล่อง',
  newChannel: 'เพิ่มช่องทาง',
  editChannel: 'แก้ไขช่องทาง',
  lookChannel: 'ดูช่องทาง',
  weightInfo: 'ข้อมูลการชั่งน้ำหนัก',
  channelNameNoEmpty: 'ชื่อช่องทางไม่สามารถเว้นว่างได้!',
  shippingTypeNoEmpty: 'วิธีการขนส่งไม่สามารถเว้นว่างได้!',
  destinationDistributionNoEmpty: 'วิธีการจัดส่งปลายทางไม่สามารถเว้นว่างได้!',
  chargingMethodNoEmpty: 'วิธีการคิดค่าบริการไม่สามารถเว้นว่างได้!',
  bubbleCountingRatioNoEmpty: 'ค่าสัมประสิทธิ์การคิดค่าปริมาตรไม่สามารถเว้นว่างได้!',
  bubbleSplittingRatioNoEmpty: 'อัตราส่วนการแบ่งค่าปริมาตรไม่สามารถเว้นว่างได้!',
  singleBoxLowestBillableWeightNoEmpty: 'น้ำหนักขั้นต่ำในการคิดค่าบริการต่อกล่องไม่สามารถเว้นว่างได้!',
  multipleBoxesCalculationRulesNoEmpty: 'กฎการคำนวณหลายกล่องไม่สามารถเว้นว่างได้!',
  settlementWeightRoundingRulesNoEmpty: 'กฎการปัดเศษน้ำหนักในการชำระเงินไม่สามารถเว้นว่างได้!',
  acceptableGoodsNoEmpty: 'กรุณาเลือกสินค้าที่รับได้อย่างน้อยหนึ่งรายการ!',
  editExistChannel: 'ช่องทางนี้ได้สร้างใบเสนอราคาแล้ว ต้องการรีเฟรชข้อมูลช่องทางในใบเสนอราคาหรือไม่?',
  notEditName: 'ช่องทางนี้ถูกนำเข้าไปในใบเสนอราคาแล้ว ไม่สามารถแก้ไขชื่อช่องทางได้',
  activeState: 'สถานะการเปิดใช้งาน',
  enable: 'เปิดใช้งาน',
  disable: 'ปิดใช้งาน',
  enableSucceed: 'เปิดใช้งานช่องทางสำเร็จ!',
  disableSucceed: 'ปิดใช้งานช่องทางสำเร็จ!',
  cannotActive: 'ไม่มีข้อมูลที่สามารถแก้ไขได้',
  exportQuotation: 'ส่งออกใบเสนอราคา',
  printQuotation: 'พิมพ์ใบเสนอราคา',
  quotationValidityPeriod: 'ระยะเวลาการเสนอราคา',
  quotationLabel: 'ป้ายกำกับใบเสนอราคา',
  previewQuotation: 'ดูตัวอย่างใบเสนอราคา',
  longTerm: 'มีผลระยะยาว',
  addOrder: 'เพิ่มคำสั่งซื้อ',
  revokeTheApprovalForm: 'ยกเลิกการอนุมัติ',
  revokeOutboundShipment: 'ยกเลิกการจัดส่ง',
  containerNo: 'หมายเลขตู้คอนเทนเนอร์',
  cannotDelete: 'ไม่อนุญาตให้ลบช่องทางที่ได้สร้างใบเสนอราคาแล้ว!'
}
